/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 10b70efd47036b72e8d1dec5d12405f81f712e3a
 */

export type ManagedCollectionKind = typeof ManagedCollectionKind[keyof typeof ManagedCollectionKind];


export const ManagedCollectionKind = {
  subcategory: 'subcategory',
  editorial: 'editorial',
  personal: 'personal',
} as const;
